import React, { FC } from 'react';
import { Logo } from '~/assets';
import { Icon, Image } from '~/components/Atoms';
import { LinkList } from '~/components/Molecules';
import {
  FOOTER_LINKS_CONTACT,
  FOOTER_LINKS_MODELS,
  FOOTER_LINKS_WWA,
  SOCIAL_MEDIA_LINKS,
} from '~/utils';
import {
  BottomWrapper,
  ImageWrapper,
  LinksWrapper,
  SocialMediaWrapper,
  Wrapper,
} from './styles';

const Footer: FC = () => {
  return (
    <Wrapper>
      <LinksWrapper>
        <LinkList {...FOOTER_LINKS_CONTACT} />
        <LinkList {...FOOTER_LINKS_MODELS} />
        <LinkList {...FOOTER_LINKS_WWA} />
      </LinksWrapper>
      <BottomWrapper>
        <SocialMediaWrapper>
          {SOCIAL_MEDIA_LINKS.map(({ icon }) => (
            <Icon key={icon} iconName={icon} />
          ))}
        </SocialMediaWrapper>
        <ImageWrapper>
          <Image src={Logo} alt="Logo" />
        </ImageWrapper>
      </BottomWrapper>
    </Wrapper>
  );
};

export default Footer;
